(function($) {
  //
  // Member Panel
  //
  var $memberPanel = $('#member_panel');
  var $memberPanelDropdown = $('#member_panel_dropdown');

  $memberPanelDropdown.on('shown.bs.dropdown', () => {
    $memberPanel.find('input').eq(0).focus();
  });

  $memberPanel.parents('.dropdown').on('click', '.dropdown-menu', event => event.stopPropagation());

  //
  // Member Form
  //
  var memberUtils = new Member({
    apiKey: local.websiteDataAPI.api_member,
  });

  var memberBooking = new Booking({
    mode: 'custom',
    params: {
      propertyId: local.booking.property_id,
    }
  });

  if (window.MemberBooking === undefined) {
    window.MemberBooking = memberBooking;
  }

  if (window.MemberUtils === undefined) {
    window.MemberUtils = memberUtils;
  }

  if (window.MemberFormSubmit === undefined) {
    window.MemberFormSubmit = function(event, form) {
      event.preventDefault();
      event.stopPropagation();

      form.classList.add('was-validated');

      if (form.checkValidity() === false) {
        return;
      }

      var $form = $(form);
      var FORMARR = $form.serializeArray();
      var FORMOBJ = [];

      for (var i = 0; i < FORMARR.length; i++) {
        var name = FORMARR[i].name;
        var value = FORMARR[i].value;
        FORMOBJ[name] = value;
      }
  
      MemberUtils.submit({
        email: FORMOBJ.member_email,
        message: 'Registered from Serenata ' + window.location.href
      });

      MemberUtils.setMember();

      // Change UI
      renderMemberWelcome();
      prepareMemberEnveronment();

      // Add member accesscode to params
      memberBooking.update('accesscode', memberUtils.getMember());

      // Open new window
      window.open(memberBooking.renderURL(), '_blank');

      // Trigger to global to know this activity
      $(window).triggerHandler('memberSubmitted', {
        code: MemberUtils.getMember()
      });
    }
  }

  if (!MemberUtils.isMember()) {
    renderMemberForm();
  } else {
    renderMemberWelcome();
    prepareMemberEnveronment();
  }

  function renderMemberForm() {
    $memberPanel
      .addClass('is-guest')
      .removeClass('is-member');

    $memberPanel.html(`<div class="member-panel__register">
      <form id="member_form" class="form-member" onsubmit="return MemberFormSubmit(event, this)" novalidate>
        <div class="form-group">
          <label for="member_email" class="mb-2">${local.member.register_content}</label>
          <input type="email" name="member_email" id="member_email" class="form-control" placeholder="${local.member.email_placeholder}" required>
          <div class="invalid-feedback">${local.member.email_label}</div>
        </div>
        <div class="form-group mb-0">
          <button type="submit" class="btn btn-primary">${local.member.email_signup}</button>
          <button type="button" class="btn btn-link btn-close" onclick="jQuery('#member_panel_dropdown').dropdown('hide');return false;">${local.member.email_cancel}</button>
        </div>
      </form>
    </div>`);
  }

  function renderMemberWelcome() {
    $memberPanel
      .addClass('is-member')
      .removeClass('is-guest');

    $memberPanel.html(`<div class="member-panel__loggedin">
      <div class="hello">Hi! Member</div>
      <div>${local.member.welcome_content}</div>
      <div class="mt-2">
        <a href="javascript:;" class="btn btn-gold" onclick="window.open(MemberBooking.renderURL({accesscode:MemberUtils.getMember()}), '_blank')">${local.member.welcome_reserve}</a>
        <a href="javascript:;" class="btn btn-link" onclick="jQuery('#member_panel_dropdown').dropdown('hide');return false;">${local.member.welcome_cancel}</a>
      </div>
    </div>`);
  }

  function prepareMemberEnveronment() {
    FormBooking.update('accesscode', MemberUtils.getMember());
    LinkBooking.update('accesscode', MemberUtils.getMember());
    RateBooking.update('accesscode', MemberUtils.getMember());
    MobileBooking.update('accesscode', MemberUtils.getMember());
    transformStaticLinks();
  }

  function transformStaticLinks() {
    var nodes = document.querySelectorAll('a[href*="https://reservation"]');
    Array.prototype.forEach.call(nodes, el =>{
      var href = el.href;
      var conj = href.indexOf('?') >= 0 ? '?' : "&";
      if (href.indexOf('booking-management') >= 0) return;
      if (href.indexOf('accesscode') >= 0) return;
      el.setAttribute('href', href + conj + 'accesscode=' + MemberUtils.getMember());
    });
  }
})(jQuery);